import { cn } from '@eliadmin/core/src/utils/style-utils';

/** Figma text styles DLZ/Heading/* = classes in `src/styles/typography.css` (spelled out for Tailwind). */
const SIZES = {
  display: 'dlz-display',
  h1: 'dlz-h1',
  h2: 'dlz-h2',
  h3: 'dlz-h3',
  h4: 'dlz-h4',
  h5: 'dlz-h5',
} as const;

export type HeadingSize = keyof typeof SIZES;

type HeadingElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div';

/**
 * Heading from the administration. The title may carry HTML (`<br>` line break, `<span>` brand
 * colour) – it is rendered as markup, never as text.
 */
export function Heading({
  title,
  size,
  as,
  id,
  className,
}: {
  title: string;
  size: HeadingSize;
  /** Semantic element; defaults to `h1` for display, otherwise to the size. */
  as?: HeadingElement;
  id?: string;
  className?: string;
}) {
  if (!title) return null;
  const Element = as ?? (size === 'display' ? 'h1' : size);

  return (
    <Element
      id={id}
      className={cn(SIZES[size], '[&_span]:text-[#D7191F]', className)}
      dangerouslySetInnerHTML={{ __html: title }}
    />
  );
}

/**
 * Overline above a heading ("ZÁKAZNÍCKA PODPORA", "ONLINE ŽELEZIARSTVO"): DLZ/UI/Label trimmed to
 * cap height, text/brand unless told otherwise.
 */
export function Eyebrow({ text, className }: { text: string; className?: string }) {
  if (!text) return null;

  return (
    <p className={cn('dlz-label text-[#D7191F]', className)}>
      <span className="dlz-trim block" dangerouslySetInnerHTML={{ __html: text }} />
    </p>
  );
}
